module.exports = __webpack_public_path__ + "static/media/about1.d21f485d.jpg";